import { render, staticRenderFns } from "./GBRightPaneMemberInfo.vue?vue&type=template&id=35a3c9b3&"
import script from "./GBRightPaneMemberInfo.vue?vue&type=script&lang=js&"
export * from "./GBRightPaneMemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./GBRightPaneMemberInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSelect,VTextField,VTextarea})
